const isCollapsed = state => state.isCollapsed;

export default {
  isCollapsed
}
